module.exports = __webpack_public_path__ + "img/test-wanchengceshi.f3597bf1.png";